import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

export const ContactSection = styled.section`
  background: ${COLORS.cloud};
  padding: 80px 0;

  ${mq({
    padding: ['0px 0', '80px 0', '100px 0'],
  })}
`;

export const Container = styled.div`
  max-width: 1050px;
  margin: 0 auto;
  padding: 0 24px;

  ${mq({
    padding: ['0 20px', '0 24px', '0 32px'],
  })}
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 90px;
  align-items: center;

  ${mq({
    gridTemplateColumns: ['1fr', '1fr', '1fr 2fr'],
    gap: ['40px', '50px', '90px'],
  })}
`;

export const LeftSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${mq({
    justifyContent: ['center', 'center', 'flex-end'],
  })}
`;

export const EnvelopeIconContainer = styled.div`
  width: 302px;
  height: 302px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(-26px 30px 20px rgba(226, 243, 242, 0.5));
  }

  ${mq({
    width: ['151px', '175px', '302px'],
    height: ['151px', '131px', '302px'],
  })}
`;

export const RightSection = styled.div`
  width: 100%;
`;

export const SectionHeading = styled.h2`
  font-family: 'Recoleta';
  font-size: 45px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 40px;
  line-height: 140%;
  letter-spacing: 0px;
  text-align: center;

  ${mq({
    fontSize: ['32px', '40px', '45px'],
    marginBottom: ['32px', '36px', '24px'],
    textAlign: ['left', 'left', 'left'],
  })}
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 572px;
  height: 484px;

  ${mq({
    gap: ['20px', '22px', '24px'],
    width: ['100%', '100%', '572px'],
    height: ['auto', 'auto', '484px'],
  })}
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  ${mq({
    gridTemplateColumns: ['1fr', '1fr', '1fr 1fr'],
    gap: ['12px', '14px', '16px'],
  })}
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const inputStyles = `
  width: 100%;
  padding: 16px 20px;
  border: 2px solid ${COLORS.grayBorder};
  border-radius: 12px;
  font-size: 16px;
  font-family: inherit;
  color: ${COLORS.panther};
  background: ${COLORS.cloud};
  transition: all 0.3s ease;
  
  &::placeholder {
    color: ${COLORS.storm};
    opacity: 0.8;
  }
  
  &:focus {
    outline: none;
    border-color: ${COLORS.tealPrimary};
    box-shadow: 0 0 0 3px rgba(9, 126, 119, 0.1);
  }
  
  &:hover {
    border-color: ${COLORS.tealPrimary};
  }
`;

export const FormInput = styled.input`
  ${inputStyles}

  ${mq({
    padding: ['14px 18px', '15px 19px', '16px 20px'],
    fontSize: ['15px', '15px', '16px'],
  })}
`;

export const FormSelect = styled.select`
  ${inputStyles}
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 16px;
  padding-right: 40px;

  option {
    color: ${COLORS.panther};
    background: ${COLORS.cloud};
  }

  ${mq({
    padding: [
      '14px 40px 14px 18px',
      '15px 40px 15px 19px',
      '16px 40px 16px 20px',
    ],
    fontSize: ['15px', '15px', '16px'],
  })}
`;

export const FormTextarea = styled.textarea`
  ${inputStyles}
  resize: vertical;
  min-height: 120px;
  font-family: inherit;

  ${mq({
    padding: ['14px 18px', '15px 19px', '16px 20px'],
    fontSize: ['15px', '15px', '16px'],
    minHeight: ['100px', '110px', '120px'],
  })}
`;

export const SubmitButton = styled.button`
  background: ${COLORS.tealPrimary};
  color: ${COLORS.cloud};
  border: none;
  border-radius: 32px;
  padding: 16px 32px;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;
  min-width: 160px;

  &:hover:not(:disabled) {
    background: ${COLORS.tealJungle};
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(9, 126, 119, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  ${mq({
    padding: ['14px 28px', '15px 30px', '16px 32px'],
    fontSize: ['16px', '17px', '18px'],
    borderRadius: ['24px', '28px', '32px'],
    minWidth: ['140px', '150px', '160px'],
  })}
`;

export const FormError = styled.span`
  color: ${COLORS.sunset};
  font-size: 14px;
  line-height: 1.5;
`;
